import {
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import AddOrEditProductsForm from './AddOrEditProductsForm'
import { EditProductModalProps } from '@/app/types/productServiceType'
import { useTranslation } from '@/app/i18n/client'
const AddorEditProductModal: React.FC<EditProductModalProps> = ({
  setOpen,
  functionality,
  id,
}) => {
  const { t } = useTranslation()
  return (
    <DialogContent
      className="border-0 !max-w-[950px] bg-[#fff] max-h-[90%] rounded-[5px] overflow-y-scroll"
      onInteractOutside={(e) => {
        e.preventDefault()
      }}
    >
      <DialogHeader className="">
        <DialogTitle className="bg-modal_header px-8 py-4 tracking-wide flex items-center gap-8  ">
          {functionality == 'Edit'
            ? `${t('EDIT PRODUCT')}`
            : `${t('Add  Product')}`}
        </DialogTitle>
      </DialogHeader>
      <AddOrEditProductsForm
        setOpen={setOpen}
        functionality={functionality}
        id={id}
      />
    </DialogContent>
  )
}

export default AddorEditProductModal
